/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pricing.sidebar.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.validate',
  'acme.common.directive.treeList'
])

.controller('PricingSidebarController', ['$scope', '$state', 'HelpersService', 'ApiService', 'CalendarService', 'ValidateService', function($scope, $state, HelpersService, ApiService, CalendarService, ValidateService) {

    $scope.pricingSidebar = {

      view: 'price',

      title: 'Manage your pricing from here',
      priceListModel: [],
      admissionListModel: [],

      search: {},

      selectedPriceListId: '',

      init: function() {
        $scope.$on('PricingController::admissionListUpdate', this.onAdmissionListUpdate);
        $scope.$on('PricingController::priceListsUpdate', this.onPriceListsUpdate);
        $scope.$on('PricingController::priceListUpdate', this.onPriceListUpdate);

        $scope.$on('$stateChangeSuccess', function(e, to, toParams, from, fromParams) {
          if (to.name === 'application.pricing.admission') {
            $scope.pricingSidebar.view = 'admission';
          }else if (to.name === 'application.pricing.lists') {
            $scope.pricingSidebar.view = 'price';
          }
        });
      },

      selectPriceList: function(id) {
        console.log('PricingSidebarController::selectPriceList');
        this.selectedPriceListId = id;
        $scope.$parent.$broadcast('PricingSidebarController::selectList', { id: id });
      },

      isSelected: function(id) {
        return (id === this.selectedPriceListId);
      },

      isView: function(name) {
        return (this.view === name);
      },

      sortByName: function() {},

      sortByDate: function() {},

      onSidebarViewChange: function(e, data) {
        $scope.pricingSidebar.updateView();
      },

      onPriceListsUpdate: function(e, data) {
        console.log('PricingSidebarController::onPriceListsUpdate');
        if (data.selectedPriceListId) {
          $scope.pricingSidebar.selectedPriceListId = data.selectedPriceListId;
        }
        $scope.pricingSidebar.priceListModel = data.model;
      },

      onAdmissionListUpdate: function(e, data) {
        var i, ii,
            items = {};


        for (i=0,ii=data.model.length;i<ii;i++) {
          if (!items.hasOwnProperty(data.model[i].type)) {
            items[data.model[i].type] = {};
          }
          if (!items[data.model[i].type].hasOwnProperty('items')) {
            items[data.model[i].type].items = [];
          }
          items[data.model[i].type].items.push(data.model[i]);
        }

        console.log('PricingSidebarController::onAdmissionListsUpdate', items);


        $scope.pricingSidebar.admissionListModel = items;
      }

    };

    $scope.pricingSidebar.init();

}]);